<template>
  <base-material-card color="primary" icon="$bpr" inline class="basic-info-consultar-bpr px-5 py-1">
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">BPR</div>
    </template>
    <v-form class="pt-5">
      <v-row align="center" no-gutters class="ml-4">
        <v-col cols="12">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="100"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider
                v-slot="{ errors }"
                :rules="dataValida ? 'required|min:7' : 'forcar_erro'"
                class="validation-provider-bpr-data-ref"
              >
                <v-text-field
                  v-model="monthFormatted"
                  v-bind="attrs"
                  v-mask="'##/####'"
                  class="text-field-bpr"
                  type="tel"
                  label="Data de Referência"
                  prepend-icon="mdi-calendar"
                  outlined
                  :error-messages="errors"
                  v-on="on"
                  @blur="monthYear = parseMonth(monthFormatted)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="monthYear"
              type="month"
              :landscape="false"
              locale="pt-br"
              @input="
                menu = false;
                monthFormatted = formatMonth(monthYear);
              "
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="ml-4">
        <v-col cols="12" class="pt-1">
          <v-alert dense outlined type="info" class="mb-0 px-1 py-0">
            Módulos Aneel oficiais atualizados até: {{ dataUltimoIpcaOficial | formatToMonth }} ({{
              mesesSemAtualizarIpcaOficial
            }}
            meses sem atualizar)
            <br />
            <template v-if="dataUltimoIpcaNaoOficial">
              Módulos Aneel estimado atualizados até: {{ dataUltimoIpcaNaoOficial | formatToMonth }}
            </template>
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="ml-4 mt-10">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-textarea
              v-model="codigos"
              :error-messages="errors"
              clearable
              outlined
              clear-icon="mdi-close-circle"
              label="Códigos MCPSE"
              placeholder="Insira os códigos MCPSE, um código por linha, seguindo o formato: TI.TUC.A1.A2.A3.A4.A5.A6"
              rows="5"
              no-resize
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import dayjs from 'dayjs';

  export default {
    mixins: [dateFormatterMixins],

    props: {
      dataUltimoIpcaOficial: {
        type: String,
        required: true
      },
      dataUltimoIpcaNaoOficial: {
        type: String,
        required: true
      },
      mesesSemAtualizarIpcaOficial: {
        type: Number,
        required: true
      }
    },

    data: () => ({
      menu: false,
      codigos: '',
      monthYear: '',
      monthFormatted: '',
      dataValida: true
    }),

    methods: {
      ValidaData() {
        const dataReferencia = dayjs(`${this.monthYear}-01`);
        const dataIPCA = this.dataUltimoIpcaOficial || this.dataUltimoIpcaNaoOficial;

        if (dataReferencia.isAfter(dataIPCA)) {
          this.dataValida = false;
          this.$toast.error('Erro: A data de Referência está incorreta, confira o ultimo IPCA .', '', { position: 'topRight' });
        }
      },

      exportData() {
        return {
          dataRegistro: `${this.monthYear}-01`,
          codigos: this.codigos
        };
      }
    },

    watch: {
      monthYear() {
        this.dataValida = true;
        this.ValidaData();
      }
    }
  };
</script>

<style>
  .text-field-bpr input {
    padding: 18px 0;
  }

  .text-field-bpr div {
    margin-bottom: 0;
  }

  .validation-provider-bpr-data-ref div:last-child {
    padding-top: 2.3px;
  }

  .v-sheet .v-card--material__heading {
    padding: 9px !important;
  }

  .basic-info-consultar-bpr svg {
    height: 46px !important;
    width: 46px !important;
  }

  .basic-info-consultar-bpr svg text,
  .basic-info-consultar-bpr svg path {
    fill: #fff !important;
    stroke: #fff !important;
    font-weight: normal !important;
  }
</style>